<template>
  <div>
    <b-card no-body class="rounded-xl border-none">
      <div class="mt-4 flex w-full items-end">
        <div class="w-1/2 pr-4">
          <base-input class="div-mb-0" label="Select Date">
            <flat-picker
              placeholder="Select Date...."
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{ allowInput: true }"
              class="form-control datepicker mt-3"
            >
            </flat-picker>
          </base-input>
        </div>
        <div class="w-1/2 pr-4">
          <base-input class="div-mb-0">
            <flat-picker
              placeholder="Select Date...."
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="{ allowInput: true }"
              class="form-control datepicker mt-3"
            >
            </flat-picker>
          </base-input>
        </div>
        <div class="w-1/2 pl-12">
          <base-button
            filled
            type="success"
            class="px-10 py-3"
            @click="toggleDetails(true)"
            >Search</base-button
          >
        </div>
      </div>

      <div class="mt-8">
        <b-input-group>
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="URLShortnerData"
        >
          <el-table-column
            label="User ID"
            min-width="100PX"
            prop="userid"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.userid }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Sender ID"
            min-width="100PX"
            prop="senderid	"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.senderid }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Camp ID"
            min-width="120px"
            prop="campid"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.campid }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Content"
            min-width="220px"
            prop="content"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.content }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Submit on"
            min-width="120px"
            prop="submit"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.submit }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Status"
            min-width="120px"
            prop="status"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.status }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Action"
            min-width="100px"
            prop="action"
            sortable
          >
            <template>
              <div class="flex items-center">
                <div class="flex items-center cursor-pointer">
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-5"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Delete"
                  ></feather-icon>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination
            v-model="currentPage"
            :per-page="10"
            :total="50"
          ></base-pagination>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import URLShortnerData from "./URLShortnerData";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    flatPicker,
  },
  data() {
    return {
      URLShortnerData,
      currentPage: 1,
      isDetailsActive: false,
      isShowCreate: false,
    };
  },
  methods: {
    toggleDetails(val = false) {
      this.isDetailsActive = val;
    },
  },
};
</script>
